import { FormattedMessage } from 'react-intl';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';
import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals/MoneyWithDecimals';
import styles from '../EarlyRepayment.module.css';
import messages from './Fees.messages';

const EarlyRepaymentFees = ({
    totalFees,
    isLoading
}: {
    totalFees: number;
    isLoading: boolean;
}) => {
    return (
        <SummaryRow isLoading={isLoading}>
            <FormattedMessage {...messages.fees} />
            <div>
                <span className={styles.always}>
                    <FormattedMessage {...messages.always} />
                </span>
                <span data-testid="early-repayment-fees">
                    <MoneyWithDecimals value={totalFees} />
                </span>
            </div>
        </SummaryRow>
    );
};

// eslint-disable-next-line import/no-default-export
export default EarlyRepaymentFees;
